import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import styled from "styled-components";
import { AppQueryClient } from "../../../api/queryClient";
import AppContext from "../../../AppContext";
import { APP_TITLE } from "../../../config/constant";
import LayoutContext from "../../../LayoutContext";
import { defaultStatusColors } from "../../../utils/CardUtils";
import { formatDefaultDate, formatDefaultDateTime } from "../../../utils/Formatter";
import * as Library from "../../../utils/Library";
import InfinityGridBOImagesCards from "../../common/cardContainers/InfinityGridBOImagesCards";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import ListComponent from "../../common/lists/ListComponent";
import MainWindowHeader from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import PublishPopUp from "../../common/PublishPopUp";

/* #region  SCOPED CSS */
const StyledPage = styled.div`
    & {
        overflow-y: hidden;
        height: 100%;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }
`;
/* #endregion */

export default function BOImagesPage() {
    const infiniteGridQuerykey = "BOImagesGrid";
    const listQueryKey = "BOImagesList";
    const gridRef = useRef(null);

    document.title = `${APP_TITLE} - BOImages`;

    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigations = useSelector(state => state.navigationAccesses);

    const [listNumRows, setListNumRows] = useState(50);

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData,
        navigations: navigations
    };

    /* #region STATES */
    const {
        setSidePanelBOtagProductLink,
        setBOTagsList,
        setSidePanelVisible,
        setSidePanelSection,
        setSidePanelProducts,
        setSidePanelHasNewLinkedProducts,
        setSidePanelRetailBrandID,
        setSidePanelProductSearchName,
        setSidePanelSelectedProductID,
        setSidePanelSelectedProductNumber,
        setBrandNotSelectedShowError
    } = React.useContext(AppContext);

    const { showFirstBOImagePopup, setShowFirstBOImagePopup } = React.useContext(LayoutContext);

    const navigate = useNavigate();
    const [viewLayoutStyle, setViewLayoutStyle] = useState("Grid");
    const [isLoading, setIsLoading] = useState(false);
    const [publishPopUp, setPublishPopUp] = useState(false);
    const [publishBOimageID, setPublishBOimageID] = useState(null);

    const [removeID, setRemoveID] = useState(null);
    const [toogleSuspendData, setToogleSuspendData] = useState(null);

    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        setViewLayoutStyle(props?.layoutType);
        setupHeaders(props, navigations, onClickRefreshAction);
    }, [props?.layoutType, navigations]);

    useEffect(() => {
        setSidePanelProducts([]);
        setBOTagsList([]);
        setSidePanelVisible(false);
        setSidePanelSection("Products");
        setSidePanelBOtagProductLink(null);
        setSidePanelHasNewLinkedProducts(false);
        setSidePanelProductSearchName("");
        setSidePanelRetailBrandID(null);
        setSidePanelSelectedProductID(undefined);
        setSidePanelSelectedProductNumber(undefined);
        setBrandNotSelectedShowError(false);
    }, []);
    /* #endregion */

    /* #region METHODS */
    const handleEdit = itemData => {
        const itemID = itemData?._id;

        if (!itemID) {
            Library.showErrorMessage("Invalid item ID!");
            return;
        }

        navigate(`/boimages/edit/${itemID}`);
    };

    const handleOnImageClick = itemData => {
        const BOimageID = itemData?.botagID;

        const urlPrefix = process.env.REACT_APP_BOTHEBOT_URL;
        const url = `${urlPrefix}${BOimageID}`;

        window.open(url, "_blank");
    };

    const handleDelete = async itemData => {
        const itemID = itemData?._id;

        if (!itemID) {
            Library.showErrorMessage("Invalid item ID!");
            return;
        }

        setRemoveID(itemID);
    };

    const makeDeleteRequest = itemID => {
        setIsLoading(true);

        /*setTimeout(() => {
        setIsLoading(false);
        setRemoveID(null);
        Library.showSuccessMessage("BOImage deleted successfully!");
    }, 2000);*/

        Library.makeCommonPostRequest("BOimages", "deleteBOimage", { BOimageID: itemID }, false, setIsLoading)
            .then(res => {
                if (res.data.status !== 200) return;
                setIsLoading(false);
                setRemoveID(null);
                onClickRefreshAction();
                Library.showSuccessMessage("BOImage deleted successfully!");
                //props?.getUserDataFunction(localStorage.getItem("token"));
            })
            .catch(err => {
                setIsLoading(false);
                setRemoveID(null);
            });
    };

    const handleToogleSuspend = itemData => {
        const itemID = itemData?._id;

        if (!itemID) {
            Library.showErrorMessage("Invalid item ID!");
            return;
        }

        setToogleSuspendData(itemData);
    };

    const toogleSuspend = itemData => {
        setIsLoading(true);

        /*setTimeout(() => {
        setIsLoading(false);
        setToogleSuspendData(null);
        Library.showSuccessMessage("BOImage suspended successfully!");
    }, 2000);*/

        //const groupCompanyID = localStorage.getItem("currentCompanyID");
        const itemID = itemData?._id;
        const status = itemData?.status === "Active" ? "Suspended" : "Active";

        Library.makeCommonPostRequest(
            "BOimages",
            "updateBOimageStatus",
            {
                BOimageID: itemID,
                status
            },
            false,
            setIsLoading
        )
            .then(res => {
                if (res.data.status !== 200) return;
                setIsLoading(false);
                setToogleSuspendData(null);
                Library.showSuccessMessage(
                    status === "Active" ? "BOImage activated successfully!" : "BOImage suspended successfully!"
                );

                onClickRefreshAction();
                //props?.getUserDataFunction(localStorage.getItem("token"));
            })
            .catch(err => {
                setIsLoading(false);
                setToogleSuspendData(null);
            });
    };

    const onClickRefreshAction = () => {
        if (props?.layoutType === "List") AppQueryClient.invalidateQueries(listQueryKey);
        else {
            //else AppQueryClient.invalidateQueries(infiniteGridQuerykey);
            gridRef.current?.reset?.(infiniteGridQuerykey);
        }
    };

    const onPublishClick = BOimage => {
        setPublishBOimageID(BOimage?.botagID);
        setPublishPopUp(true);
    };

    const onDetailsClick = BOimage => {
        navigate(`/boimages/${BOimage?._id}`);
    };
    /* #endregion */

    /* #region LIST COMPONENT PROPS */
    const listColumns = [
        {
            name: "ID",
            selector: row => row?.botagID ?? "--"
        },
        {
            name: "Active Period",
            selector: row =>
                row?.activePeriodStart && row?.activePeriodEnd
                    ? `${formatDefaultDate(row?.activePeriodStart)} to ${formatDefaultDate(row?.activePeriodEnd)}`
                    : "--"
        },
        {
            name: "Created by",
            selector: row => row?.createdBy ?? "--"
        },
        {
            name: "Created On",
            selector: row => formatDefaultDateTime(row?.createdOn)
        }
    ];
    /* #endregion */

    return (
        <StyledPage>
            <FullScreenOverlay show={toogleSuspendData !== null}>
                <DialogBoxComponent
                    title={toogleSuspendData?.status === "Active" ? "Suspend BOImage" : "Activate BOImage"}
                    message={
                        toogleSuspendData?.status === "Active"
                            ? `Are you sure you want to suspend ${toogleSuspendData?.name} BOImage?`
                            : `Are you sure you want to activate ${toogleSuspendData?.name} BOImage?`
                    }
                    onClickYes={() => {
                        toogleSuspend(toogleSuspendData);
                    }}
                    loading={isLoading}
                    loadingHeading={
                        toogleSuspendData?.status === "Active" ? "Suspending BOImage..." : "Activating BOImage..."
                    }
                    onClickNo={() => {
                        setToogleSuspendData(null);
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={removeID !== null}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-red-500)"
                    title="Removing BOImage"
                    message="Are you sure you want to remove this BOImage?"
                    onClickYes={() => {
                        makeDeleteRequest(removeID);
                    }}
                    loading={isLoading}
                    loadingHeading="Removing BOImage..."
                    onClickNo={() => {
                        setRemoveID(null);
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showFirstBOImagePopup}>
                <DialogBoxComponent
                    headingFontSize="16px"
                    buttonWidth="151px"
                    buttonFontSize="12px"
                    onClickYes={() => {
                        navigate("/retailers/invite");
                        setShowFirstBOImagePopup(false);
                    }}
                    onClickNo={() => {
                        navigate("/stores/create");
                        setShowFirstBOImagePopup(false);
                    }}
                    title="First BOimage created!"
                    heading="DONE!"
                    //headingColor="#00BB00"
                    message="<div style='font-size: 14px; margin: 0 -5px;'>Before you can publish this BOimage, enroll some stores.</div>"
                    showConfirm={true}
                    showCancel={true}
                    cancelText="ENROLL OWN STORES"
                    confirmText="INVITE OTHER STORES"
                    cancelState="primary"
                    showCloseButton={true}
                    onClickCloseBtn={() => {
                        setShowFirstBOImagePopup(false);
                    }}
                />
            </FullScreenOverlay>

            {publishPopUp && (
                <FullScreenOverlay
                    children={<PublishPopUp setPublishPopUp={setPublishPopUp} BOimageID={publishBOimageID} />}
                />
            )}
            {viewLayoutStyle === "Grid" && (
                <InfinityGridBOImagesCards
                    ref={gridRef}
                    minColumnWidth="238px"
                    limit={12}
                    primaryButton={{ onClick: item => onDetailsClick(item) }}
                    secondaryButton={{ onClick: item => onPublishClick(item) }}
                    onEditAction={handleEdit}
                    onDeleteAction={handleDelete}
                    onSuspendAction={handleToogleSuspend}
                    onImageClick={handleOnImageClick}
                    queryKey={infiniteGridQuerykey}
                />
            )}
            {viewLayoutStyle === "List" && (
                <ListComponent
                    title="BOImages"
                    columns={listColumns}
                    api={{
                        endpoint: "getBOimagesData",
                        formData: {
                            companyID: localStorage.getItem("currentCompanyID"),
                            limit: listNumRows
                        },
                        useCommonPostRequest: true,
                        commonContext: "BOImages"
                        //onSuccess: mapListData
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={listQueryKey}
                    actions={{
                        includeActions: true,
                        onClickEdit: handleEdit,
                        onClickRemove: handleDelete,
                        onClickSuspend: handleToogleSuspend,
                        //editIsVisible: false,
                        extraActions: [
                            {
                                title: "Details",
                                onClick: item => onDetailsClick(item)
                            },
                            {
                                title: "Publish",
                                onClick: item => onPublishClick(item)
                            }
                        ]
                    }}
                    includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            )}
        </StyledPage>
    );
}

function setupHeaders(props, navigations, onClickRefreshAction) {
    const createMode = navigations?.navigationAccesses?.BOimages?.createModeOnly;

    props.setControlBarLeftBtns([
        { to: "#", disabled: false, title: "BOImages", icon: "fa-magnifying-glass", isSearchToogle: true }
    ]);
    props.setControlBarCenterBtns([{ to: "/boimages", active: true, disabled: false, title: "BOIMAGES" }]);
    props.setControlBarRightBtns([
        { to: "/boimages", active: true, disabled: createMode, title: "View", icon: "eye" },
        { to: "/boimages/create", active: false, disabled: false, title: "Add", icon: "plus" },
        { to: "/boimages/empty", active: false, disabled: createMode, title: "Details", icon: "microscope" }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeader
                key={window.location.pathname}
                visible={true}
                onRefreshClick={onClickRefreshAction}
                layoutTypeOptions={{
                    gridEnabled: true,
                    listEnabled: true
                }}
                firstOrganize={{
                    visible: true,
                    disabled: true
                }}
                secondOrganize={{
                    visible: true,
                    disabled: true
                }}
                search={{
                    searchPlaceholder: "Search"
                    //onSearch: onSearch
                }}
            />
        )
    });
}
